import {LabelRegular, TextMedium} from '@hm/fundamental'
import {CircularProgress} from '@material-ui/core'
import {AxiosError} from 'axios'
import React from 'react'

import {useHaulier} from '../../hooks/useHaulier'
import {useTranslation} from '../../hooks/useTranslation'

type RoleHaulierLookupChipProps = {
  haulierId: string
  error?: Error
}

export const RoleHaulierLookupChip = ({haulierId}: RoleHaulierLookupChipProps) => {
  const {t} = useTranslation()

  const haulierQueryInfo = useHaulier({haulierId})
  const haulier = haulierQueryInfo.data

  if (haulierQueryInfo.isLoading) {
    return <CircularProgress size="20" />
  }

  if (haulierQueryInfo.isError) {
    return (
      <div className="flex flex-col items-start">
        <TextMedium className="text-foreground">{haulierId}</TextMedium>
        <TextMedium className="text-foreground">Error: Could not load haulier</TextMedium>
        <TextMedium className="text-foreground">
          {(haulierQueryInfo.error as AxiosError).message}
        </TextMedium>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-start" data-test-id="manageUser.haulier">
      <LabelRegular className="text-foreground_faded">{t('manageUser.haulier')}</LabelRegular>
      <TextMedium className="text-foreground">{haulier?.haulierName}</TextMedium>
      <LabelRegular className="text-foreground_faded">{haulier?.haulierNumber}</LabelRegular>
    </div>
  )
}
